import { render, staticRenderFns } from "./LinksAttributeEditor.vue?vue&type=template&id=11917181"
import script from "./LinksAttributeEditor.vue?vue&type=script&lang=js"
export * from "./LinksAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports